@file:OptIn(InternalResourceApi::class)

package linkgame_master.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/linkgame_master.composeapp.generated.resources/"

@delegate:ResourceContentHash(-929_930_860)
public val Res.font.noto_sans_sc_regular: FontResource by lazy {
      FontResource("font:noto_sans_sc_regular", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("noto_sans_sc_regular", Res.font.noto_sans_sc_regular)
}
